<template>
  <a-modal
    title="创建班次信息"
    @ok="saveCarFlow"
    :visible="requModel"
    @cancel="() => {
      requModel = !requModel
    }"
  >
    <a-form-model hideRequiredMark ref="ruleForm">
      <a-form-model-item label="价格" class="m-b-10" prop="price">
        <a-input :placeholder="'请输入'" type="Number" v-model="data.price" />
      </a-form-model-item>
      <a-form-model-item label="开始时间" class="m-b-10" prop="startTime">
        <a-time-picker
          @change="startTimeChange"
          style="width: 100%;"
          v-model="data.startTime"
          format="HH:mm"
        />
      </a-form-model-item>
      <a-form-model-item label="结束时间" class="m-b-10" prop="endTime">
        <a-time-picker
          @change="endTimeChange"
          style="width: 100%;"
          v-model="data.endTime"
          format="HH:mm"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
const vm = Vue.prototype
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      requModel: true, // 车流量model弹框
      data: {
        startTime: null,
        endTime: null,
        price: ''
      }
    }
  },
  methods: {
    moment,
    // 开始时间
    startTimeChange (time) {
      if (this.data.endTime) {
        if (this.moment(this.data.startTime) >= this.moment(this.data.endTime)) {
          this.data.startTime = null
          return this.$notification['warning']({
            message: '提示',
            description: '结束时间必须大于起始时间！'
          })
        }
      }
      this.data.startTime = time
    },
    // 结束时间
    endTimeChange (time) {
      if (this.data.startTime) {
        if (this.moment(this.data.startTime) >= this.moment(this.data.endTime)) {
          this.data.endTime = null
          return this.$notification['warning']({
            message: '提示',
            description: '结束时间必须大于起始时间！'
          })
        }
      }
      this.data.endTime = time
    },
    // 保存班次
    async saveCarFlow () {
      try {
        let params = {
          startTime: String(this.data.startTime.hours()).padStart(2, '0') + ':' + String(this.data.startTime.minutes()).padStart(2, '0'),
          endTime: String(this.data.endTime.hours()).padStart(2, '0') + ':' + String(this.data.endTime.minutes()).padStart(2, '0'),
          price: Number(this.data.price)
        }
        if (!this.data.startTime) {
          return this.$notification['warning']({
            message: '提示',
            description: '请选择开始时间！'
          })
        }
        if (!this.data.endTime) {
          return this.$notification['warning']({
            message: '提示',
            description: '请选择结束时间！'
          })
        }
        let reg = /^\+?[1-9]\d*$/
        if (!reg.test(this.data.price)) {
          return this.$notification['warning']({
            message: '提示',
            description: '价格请输入大于等于0的整数！'
          })
        }

        await this.$tkParse.post('/classes/frequency', params)
        vm.$notification['success']({
          message: '操作成功',
          description: '创建成功！'
        })
        this.requModel = false
        this.vm.refresh() // 数据更新后，你可能需要刷新modelTable
        this.$emit('complete') // 触发complete事件，会自动关闭该组件
      } catch (e) {
        console.log(e)
        return this.$notification['error']({
          message: '创建失败',
          description: '网络原因添加失败，请稍后重试！'
        })
      }
    }
  }
}
</script>
